/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_GenericInputs */

const en_import_fail_generic = /** @type {(inputs: Import_Fail_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The import failed`)
};

const de_import_fail_generic = /** @type {(inputs: Import_Fail_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Import ist fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "The import failed" |
*
* @param {Import_Fail_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_generic = /** @type {((inputs?: Import_Fail_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_generic(inputs)
	return en_import_fail_generic(inputs)
});